import React from "react";
import { getFormattedPrice } from "../../../services/helper";

const FinancialSummary = ({ registerInfo }) => {
  const {
    initial_cash,
    final_cash,
    total_sales,
    total_amount,
    total_discount,
    total_tax,
    refund_amount,
  } = registerInfo;

  return (
    <div className="mb-4 border-bottom pb-3">
      <h4 className="mb-3">Financial Summary</h4>
      <div className="row">
        <div className="col-md-6">
          <p>
            <strong>Initial Cash:</strong> {getFormattedPrice(initial_cash)}
          </p>
          <p>
            <strong>Final Cash:</strong> {getFormattedPrice(final_cash)}
          </p>
          <p>
            <strong>Total Sales:</strong> {total_sales}
          </p>
        </div>
        <div className="col-md-6">
          <p>
            <strong>Total Amount:</strong> {getFormattedPrice(total_amount)}
          </p>
          <p>
            <strong>Total Discount:</strong> {getFormattedPrice(total_discount)}
          </p>
          <p>
            <strong>Total Tax:</strong> {getFormattedPrice(total_tax)}
          </p>
          {parseFloat(refund_amount || 0) > 0 && (
            <>
              <p style={{ color: "red" }}>
                <strong>Refund:</strong> -{getFormattedPrice(refund_amount)}
              </p>
              <p style={{ fontWeight: "bold", fontSize: "1.1em" }}>
                <strong>Net Cash:</strong> {getFormattedPrice(parseFloat(total_amount || 0) - parseFloat(refund_amount || 0))}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FinancialSummary;
